import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
type OrigenValue = {
  active: boolean;
  toggle: () => void;
};
const OrigenContext = createContext<OrigenValue>({
  active: false,
  toggle: () => undefined
});
type OrigenProviderProps = {
  children: React.ReactNode;
};
export function OrigenProvider({
  children
}: OrigenProviderProps) {
  const [active, setActive] = useState(false);
  const toggle = useCallback(() => setActive(prev => !prev), []);
  const value = useMemo(() => ({
    active,
    toggle
  }), [active, toggle]);
  return <OrigenContext.Provider value={value} data-id="element-362" data-mp="uy1bt6esbe31">{children}</OrigenContext.Provider>;
}
export function useOrigen(): OrigenValue {
  return useContext(OrigenContext);
}